export class DialogModelNewMed {
    constructor(
      public data:any
    ) {}
  }